import * as React from 'react'
import classNames from 'classnames'

import classes from './style.module.scss'

interface YoutubeEmbedProps {
  embedId: string
  className?: string
}

export const YoutubeEmbed: React.FC<YoutubeEmbedProps> = ({ embedId, className }) => (
  <div className={classNames(classes.wrapper, className)}>
    <iframe
      className={classes.frame}
      width="100%"
      height="100%"
      src={`https://www.youtube.com/embed/${embedId}`}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
)
